import React from 'react';
import useAccountOrders from '@ubeya/shared/hooks/account/useAccountOrders';
import OrdersSummaryModal from './OrdersSummaryModal';

const OrdersSummaryByAccountWrapper = ({ onClose, stats }) => {
  const { orders } = useAccountOrders();

  return <OrdersSummaryModal onClose={onClose} orders={orders} stats={stats} showBranch />;
};

export default OrdersSummaryByAccountWrapper;
